__turbopack_context__.v({
  "sellerVacationBanner": "styles-module__-xk0fa__sellerVacationBanner",
});
